import { isEmptyList, isEmptyString, notIsEmptyList, notIsEmptyString, path } from "../../../../utils";
import { getImage } from "../../../../resources/images";

export const getThemeColor = data => path(data, 'theme_color', '#4dc247', notIsEmptyString);

export const getHeaderColor = data => path(data, 'header_color', 'white', notIsEmptyString);

export const getHeaderTextColor = data => path(data, 'header_text_color');

export const getBrandLogo = data => getImage(path(data, 'brand_logo', 'oyo_logo_square_red_back_white_text.jpeg', notIsEmptyString));

export const getBrandTitle = data => path(data, 'brand_title', 'OYO Rooms', notIsEmptyString);

export const getBrandDescription = data => path(data, 'brand_description', 'Let us help you partner with us', notIsEmptyString);

export const getChatBoxBackground = data => getImage(path(data, 'chat_background', 'whatsapp_chat_background.jpg', notIsEmptyString));

export const getMessageTitle = data => path(data, 'message_title', 'OYO Rooms', notIsEmptyString);

export const getMessageContent = data => path(data, 'message_content', ['Hi there!', 'Nice to see you', 'How can I help you today?'], notIsEmptyList);

export const getCtaText = data => path(data, 'start_button_text', 'Start Chat', notIsEmptyString);

export const getRedirectLink = data => {
    const first_msg = path(data, 'first_msg');
    return `https://api.whatsapp.com/send?phone=${getPhoneNumber(data)}` + (isEmptyString(first_msg) ? '' : `&text=${first_msg}`);
}

export const getPhoneNumber = data => {
    const phoneNumbers = path(data, 'phones', [], notIsEmptyList);

    if (isEmptyList(phoneNumbers)) return '';

    const phoneNumberStrategy = path(data, 'phone_strategy', 'random', notIsEmptyList);

    switch (phoneNumberStrategy) {
        default: case 'random': return phoneNumbers[Math.floor(Math.random() * phoneNumbers.length)];

        case 'time_slot': return path(phoneNumbers, `${[Math.ceil((phoneNumbers.length * (new Date().getHours() + 1) / 24) - 1)]}`, phoneNumbers[0]);
    }
}